/* @flow */
import * as React from 'react';

import Button from 'components/Button';
import Container from 'components/Container';
import MakeACallModal from 'phoneCalls/components/MakeACallModal';
import TitleHeader from 'components/TitleHeader';
import ModalTrigger from 'components/ModalTrigger';

export default function PhoneCallsNull() {
  const button = (
    <ModalTrigger modal={<MakeACallModal />}>
      <Button eventElementName="make_a_call_button_null">Make a call</Button>
    </ModalTrigger>
  );

  return (
    <Container size="medium" className="PhoneCallsNull">
      <TitleHeader
        action={button}
        flush
        image={require('assets/images/phoneCalls/phone-tab-null.svg')}
        imageSize="xxsmall"
        subtext="Keep calls safe with anonymized phone numbers and automatic logging."
        title="Make calls as easily as you send Remind messages"
        size="large"
      />
    </Container>
  );
}
